import { Routes } from '@angular/router';
import {
  ordersDepricatedRouteRedirect,
  prDepricatedRouteRedirect,
} from '@vectronic/oof/shared/util';
import { hasRole } from './shared/guards/keycloak.guard';

export const oofRoutes: Routes = [
  {
    path: 'complete-order-form',
    title: 'Complete Order Form',
    loadComponent: () =>
      import('@vectronic/oof/feature-complete-order-form').then(
        (c) => c.CompleteOrderFormPageComponent,
      ),
    canMatch: [hasRole],
    data: { requiredRoles: ['ROLE_ADMIN'] },
  },
  {
    path: 'production-record', // TODO: remove path in ~3 months
    title: 'Production Record',
    loadComponent: () =>
      import('@vectronic/oof/feature-production-record').then(
        (c) => c.ProductionRecordPageComponent,
      ),
    canActivate: [prDepricatedRouteRedirect],
    canMatch: [hasRole],
    data: { requiredRoles: ['ROLE_ADMIN'] },
  },
  {
    path: '',
    title: 'Orders',
    loadComponent: () => import('@vectronic/oof/feature-orders').then((c) => c.OrdersPageComponent),
    canActivate: [ordersDepricatedRouteRedirect], // TODO: remove in ~3 months
    children: [
      { path: ':orderId', children: [] },
      { path: ':orderId/items/:orderItemId', children: [] },
      {
        path: ':orderId/items/:orderItemId/configurations/:orderItemConfigurationId',
        children: [],
      },
    ],
  },
  {
    path: ':orderId/items/:orderItemId/configurations/:orderItemConfigurationId/production-record',
    title: 'Production Record',
    loadComponent: () =>
      import('@vectronic/oof/feature-production-record').then(
        (c) => c.ProductionRecordPageComponent,
      ),
    canMatch: [hasRole],
    data: { requiredRoles: ['ROLE_ADMIN'] },
  },
];
